import http from '@/utils/request'

const req = (url, method = 'get') => ({ url, [method]: async function (data = {}, config) {
  const actual = this.url.replace(/\{id\}/g, data && data.id != null ? data.id : '')
  if (method === 'get') return await http.get(actual, data)
  if (method === 'delete') return await http.delete(actual, data, config)
  return await http.post(actual, data, config)
} })

export default {
  me: req('oms/me'),
  menus: req('oms/menus'),
  changePassword: req('oms/password', 'post'),
  staffPage: req('oms/admin/staff'),
  saveStaff: req('oms/admin/staff', 'post'),
  staffStatus: req('oms/admin/staff/{id}/status', 'post'),
  resetPassword: req('oms/admin/staff/{id}/reset-password', 'post'),
  deleteStaff: req('oms/admin/staff/{id}', 'delete'),
  roles: req('oms/admin/roles'),
  saveRole: req('oms/admin/roles', 'post'),
  deleteRole: req('oms/admin/roles/{id}', 'delete'),
  resources: req('oms/admin/resources'),
  roleResources: req('oms/admin/roles/{id}/resources'),
  roleStaff: req('oms/admin/roles/{id}/staff')
}
